<template>
    <div class="customerMain" id="bigdata">
        <div class="autoWidth">
            <div class="quanp">
                <el-button
                    id="fullScreen"
                    @click="showFullScreen"
                    type="primary"
                    >{{ onFullScreen ? "退出全屏" : "进入全屏" }}
                </el-button>
            </div>
            <div class="customerTop">
                <img
                    src="../../../assets/supervise/customerTitle.png"
                    alt=""
                    srcset=""
                />
                <div class="titleFirst"></div>
                <div class="titleSecond"></div>
                <h1>{{this.orgName}}智慧养老可视化</h1>
            </div>
            <!-- tab切换 -->
            <div class="customerTab">
                <span
                    @click="changeTab(0)"
                    :class="customerIndex == 0 ? 'curIndex' : ''"
                    >居家养老</span
                >
                <span
                    @click="changeTab(1)"
                    :class="customerIndex == 1 ? 'curIndex' : ''"
                    >社区养老</span
                >
                <span
                    @click="changeTab(2)"
                    :class="customerIndex == 2 ? 'curIndex' : ''"
                    >机构养老</span
                >
                <span
                    @click="changeTab(3)"
                    :class="customerIndex == 3 ? 'curIndex' : ''"
                    >服务体系</span
                >
            </div>
            <!-- 切换内容 -->
            <div class="tabContent">
                <customer-home v-if="customerIndex == 0"></customer-home>
                <institution-home v-if="customerIndex == 2"></institution-home>
                <social-old v-if="customerIndex == 1"></social-old>
                <serve-system v-if="customerIndex == 3"></serve-system>
            </div>
        </div>
    </div>
</template>

<script>
import customerHome from "./customerHome.vue"
import institutionHome from "./institutionHome.vue"
import socialOld from "./socialOld.vue"
import serveSystem from "./serveSystem.vue"
import exportVue from "@/utils/exportVue"
export default {
    data() {
        return {
            customerIndex: 0,
            onFullScreen: false,
            orgName:"",
        }
    },
    components: {
        customerHome,
        institutionHome,
        socialOld,
        serveSystem,
    },
    created() {
        this.$store.commit("centerFull", false)
        this.customerIndex = 0
        this.orgName = this.$store.state.info.orgName
        if (sessionStorage.getItem("customerIndex")) {
            this.customerIndex = sessionStorage.getItem("customerIndex")
        }
    },
    mounted() {
        const self = this
        document.addEventListener(
            "fullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "msfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "mozfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "webkitfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
    },
    methods: {
        // 模块切换
        changeTab(index) {
            this.customerIndex = index
            sessionStorage.setItem("customerIndex", index)
        },
        // 控制全屏展示
        showFullScreen() {
            this.onFullScreen = !this.onFullScreen
            exportVue.$emit("isSHow", true)
            if (this.onFullScreen) {
                var docElm = document.documentElement
                if (docElm.requestFullscreen) {
                    docElm.requestFullscreen()
                } else if (docElm.msRequestFullscreen) {
                    docElm = document.body //overwrite the element (for IE)
                    docElm.msRequestFullscreen()
                } else if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen()
                } else if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen()
                }
                this.$store.commit("centerFull", true)
            } else {
                this.$store.commit("centerFull", false)
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                }
            }
        },
        FullCreeen(element) {
            let el = document.getElementById("bigdata")
            let rfs =
                el.requestFullScreen ||
                el.webkitRequestFullScreen ||
                el.mozRequestFullScreen ||
                el.msRequestFullScreen
            if (typeof rfs != "undefined" && rfs) {
                rfs.call(el)
                this.$store.commit("centerFull", true)
            } else if (typeof window.ActiveXObject != "undefined") {
                let wscript = new ActiveXObject("WScript.Shell")
                if (wscript != null) {
                    wscript.SendKeys("{F11}")
                }
            }
        },
    },
    destroyed() {
        sessionStorage.removeItem("customerIndex")
    },
}
</script>

<style lang='less' scoped>
.customerMain {
    position: relative;
    height: 100%;
    background: #021d36;
    .customerTop {
        img {
            width: 100%;
            height: 88px;
        }
        h1 {
            color: #6ebcff;
            position: absolute;
            text-align: center;
            font-weight: bolder;
            font-size: 35px;
            left: 0;
            top: 0;
            width: 100%;
            height: 78px;
            line-height: 78px;
            z-index: 3;
        }
        .titleFirst {
            min-width: 560px;
            position: absolute;
            width: 560px;
            border-top: 78px solid #1e69b6;
            border-left: 40px solid transparent;
            border-right: 40px solid transparent;
            height: 0;
            left: 50%;
            top: 0;
            margin-left: -310px;
            z-index: 2;
        }
        .titleSecond {
            min-width: 620px;
            width: 620px;
            position: absolute;
            border-top: 78px solid #103b71;
            border-left: 40px solid transparent;
            border-right: 40px solid transparent;
            height: 0;
            left: 50%;
            top: 0;
            margin-left: -340px;
        }
    }
    .autoWidth {
        max-width: 1920px;
        margin: auto;
        position: relative;
        height: 100%;
    }
    .customerTab {
        position: absolute;
        left: 0px;
        top: 92px;
        right: 0px;
        width: 100%;
        height: 40px;
        text-align: center;
        color: #4a6fb4;
        font-size: 16px;
        z-index: 999;
        span {
            display: inline-block;
            cursor: pointer;
            width: 120px;
            line-height: 38px;
            border: 2px solid rgba(46, 158, 255, 0.8);
            margin-right: 12px;
            border-radius: 5px;
            &.curIndex {
                background: #2889fe;
                color: #fff;
            }
            &:last-child {
                margin-right: 0px;
            }
        }
    }
    .quanp {
        right: 10px;
        top: 15px;
        position: absolute;
        z-index: 100;
        .quanp button {
            padding: 10px;
        }
    }
}
</style>